import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetAdvertisingAndMediaPlanForTheProject = createAsyncThunk(
  "AdvertisingAndMediaPlanForTheProject/GetAdvertisingAndMediaPlanForTheProject",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AP_AdvertisingPlan/GetAdvertisingPlan",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result.result; // Assuming response has a "data" field
      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAdvertisingPlan = createAsyncThunk(
  "AP_AdvertisingPlan/UpdateAdvertisingPlan",
  async (AdvertisingPlan, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AP_AdvertisingPlan/UpdateAdvertisingPlan",
        {
          aP_AdvertisingAndMediaPlanId:
            AdvertisingPlan.aP_AdvertisingAndMediaPlanId,
          mediaAndAdvertisingPlanExplanation:
            AdvertisingPlan.mediaAndAdvertisingPlanExplanation,
          aI_ApplicationInformationId:
            AdvertisingPlan.aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result.result; // Assuming response has a "data" field
      //console.log(data, "data");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateAdvertisingPlan = createAsyncThunk(
  "AP_AdvertisingPlan/ValidateAdvertisingPlan",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AP_AdvertisingPlan/ValidateAdvertisingPlan",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result.result; // Assuming response has a "data" field
      //console.log(data, "data");
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const AdvertisingAndMediaPlanForTheProject = createSlice({
  name: "AdvertisingAndMediaPlanForTheProject",
  initialState: {
    AdvertisingAndMediaPlanForTheProject: {},
    loadingGetAdvertisingAndMediaPlanForTheProject: false,
    errorGetAdvertisingAndMediaPlanForTheProject: null,

    AdvertisingAndMediaPlanForTheProjectUpdate: {},
    loadingUpdateAdvertisingPlan: false,
    errorUpdateAdvertisingPlan: null,

    AdvertisingAndMediaPlanForTheProjectValidate: [],
    loadingValidateAdvertisingPlan: false,
    errorValidateAdvertisingPlan: null,
  },
  reducers: {
    SetAdvertisingAndMediaPlanForTheProject: (state, action) => {
      state.AdvertisingAndMediaPlanForTheProject = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetAdvertisingAndMediaPlanForTheProject.pending,
        (state, action) => {
          state.loadingGetAdvertisingAndMediaPlanForTheProject = true;
          state.AdvertisingAndMediaPlanForTheProject = action.payload;
          state.errorGetAdvertisingAndMediaPlanForTheProject = null;
        }
      )
      .addCase(
        GetAdvertisingAndMediaPlanForTheProject.fulfilled,
        (state, action) => {
          state.loadingGetAdvertisingAndMediaPlanForTheProject = false;
          state.AdvertisingAndMediaPlanForTheProject = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetAdvertisingAndMediaPlanForTheProject.rejected,
        (state, action) => {
          state.loadingGetAdvertisingAndMediaPlanForTheProject = false;
          state.errorGetAdvertisingAndMediaPlanForTheProject = action.payload;
        }
      )

      .addCase(UpdateAdvertisingPlan.pending, (state, action) => {
        state.loadingUpdateAdvertisingPlan = true;
        state.AdvertisingAndMediaPlanForTheProjectUpdate = action.payload;
        state.errorUpdateAdvertisingPlan = null;
      })
      .addCase(UpdateAdvertisingPlan.fulfilled, (state, action) => {
        state.loadingUpdateAdvertisingPlan = false;
        state.AdvertisingAndMediaPlanForTheProjectUpdate = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateAdvertisingPlan.rejected, (state, action) => {
        state.loadingUpdateAdvertisingPlan = false;
        state.errorUpdateAdvertisingPlan = action.payload;
      })

      .addCase(ValidateAdvertisingPlan.pending, (state, action) => {
        state.loadingValidateAdvertisingPlan = true;
        state.AdvertisingAndMediaPlanForTheProjectValidate = action.payload;
        state.errorValidateAdvertisingPlan = null;
      })
      .addCase(ValidateAdvertisingPlan.fulfilled, (state, action) => {
        state.loadingValidateAdvertisingPlan = false;
        state.AdvertisingAndMediaPlanForTheProjectValidate = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidateAdvertisingPlan.rejected, (state, action) => {
        state.loadingValidateAdvertisingPlan = false;
        state.errorValidateAdvertisingPlan = action.payload;
      });
  },
});

export const { SetAdvertisingAndMediaPlanForTheProject } =
  AdvertisingAndMediaPlanForTheProject.actions;

export default AdvertisingAndMediaPlanForTheProject.reducer;
